/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-10-12 18:10:33
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-13 14:53:18
 * @FilePath: \crm-product\found\views\mdm\views\dealer_address\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {
  ProcessLog,
} from '@/found/modules';
import BasePage from '../../../../../components/table_page';
import Form from '../form';
import ConditionLog from '../logs/detail.vue';

export default {
  name: 'dealer_address',
  extends: BasePage,
  data() {
    return {};
  },
  components: {
    Form,
    ProcessLog,
    ConditionLog,
  },
  created() {
    this.getConfigList('main-list');
  },
  methods: {
    clickVisible({
      row,
      val: {
        code,
      },
    }) {
      const {
        status,
        processNo,
      } = row;

      if (code === 'process_log' && !processNo) {
        return false;
      }

      if (code === 'edit' && status !== '1' && status !== '4') {
        return false;
      }
      return true;
    },
    modalClick({
      val,
      row,
    }) {
      const {
        code,
      } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.formConfig = {
          ...this.formConfig,
          code,
          row,
        };
        this.modalConfig.width = '50%';
        this.modalConfig.title = val.name || '查看';
        this.openModal();
      } else if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: {
            processNo: row.processNo,
          },
        };
        this.modalConfig.title = '流程日志';
        this.formName = 'ProcessLog';
        this.openDrawer();
      } else if (val.code === 'condition_log') {
        this.formConfig = {
          mainId: row.id,
        };
        this.modalConfig.title = '操作日志';
        this.modalConfig.width = '70%';
        this.formName = 'ConditionLog';
        this.openDrawer();
      }
    },
  },
};
